import { render, staticRenderFns } from "./MarketSize.vue?vue&type=template&id=064c92d6"
import script from "./MarketSize.vue?vue&type=script&lang=js"
export * from "./MarketSize.vue?vue&type=script&lang=js"
import style0 from "./MarketSize.vue?vue&type=style&index=0&id=064c92d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports